import {getUser} from './auth'

export const getApiUrl = () => {
  const apiId = 'qhlneizp9c'
  return `https://${apiId}.execute-api.us-east-2.amazonaws.com/Prod`
};


export const generate = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/generate'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const createTemplate = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/template'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const updateTemplate = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/template'
    const response = await fetch(getApiUrl()+q, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const updateDocument = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/document'
    const response = await fetch(getApiUrl()+q, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const deleteDocument = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/document'
    const response = await fetch(getApiUrl()+q, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const getTemplateById = async (user, templateId, onSuccess, onError, retries=3) => {
  try {
    let q = '/template/'+templateId
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
}

export const getDocumentById = async (user, documentId, onSuccess, onError, retries=3) => {
  try {
    let q = '/document/'+documentId
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
}

export const getTemplateIds = async (user, onSuccess, onError, retries=3) => {
  try {
    let q = '/template'
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
}

export const getDocumentIds = async (user, onSuccess, onError, retries=3) => {
  try {
    let q = '/document'
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
}
